module.exports={render:function (){var _vm=this;
  return (!_vm.isHideSelectStudent) ? _vm._h('div', {
    staticClass: "maskdiv",
    on: {
      "click": _vm.close
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    staticStyle: {
      "padding": "0 5px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('mt-index-list', [_vm._h('strong', {
    staticClass: "tit"
  }, ["选择学生"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.studentFirstCharList), function(firstCharList) {
    return _vm._h('mt-index-section', {
      attrs: {
        "index": firstCharList.firstChar
      }
    }, [_vm._h('li', {
      staticClass: "list-group-item primary"
    }, [_vm._l((firstCharList.students), function(student) {
      return _vm._h('div', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.selected(student)
          }
        }
      }, [_vm._h('div', {
        staticClass: "clearfix",
        staticStyle: {
          "padding": "10px 15px"
        }
      }, [_vm._h('span', {
        staticClass: "pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "pull-right img-checkbox",
        class: {
          'checked': student.isChecked
        }
      })]), " ", _vm._h('div', {
        staticClass: "liner"
      })])])
    })])])
  })]), " ", _vm._h('div', {
    staticClass: "text-center"
  }, [_vm._h('a', {
    staticClass: "button button-rounded button-line",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, ["确定"])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-3b3f6c4c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/student/dialogStudents.vue
// module id = 193
// module chunks = 1